import {
  Component,
  Input,
  AfterViewInit,
  AfterContentInit,
  ContentChildren,
  QueryList,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { ExpressionOptionComponent } from './expression-option.component';
import { ExpressionOptionDropdownOptionComponent } from './expression-option-dropdown-option.component';
import { SerialSearchExpression } from '../../search-expression/serial-search-expression.model';
import { FieldTypeEnum } from '../../search-expression/field-type.enum';
import { DatePeriodEnum } from '../../search-expression/date-period.enum';
import { FieldValueOperatorEnum } from '../../search-expression/field-value-operator.enum';
import { BinaryOperatorEnum } from '../../search-expression/binary-operator.enum';

@Component({
  selector: 'wl-expression',
  templateUrl: 'expression.component.html',
  styleUrls: ['expression.component.less'],
  standalone: false,
})
export class ExpressionComponent implements AfterContentInit {
  @Input() public binarySelectorHidden: boolean;
  @Input() public searchExpression: SerialSearchExpression;
  @Input() public excludeExtraDateOptions: boolean;
  @Input() public showBetweenDateOption = true;

  public fieldTypeEnum: object = FieldTypeEnum;
  public datePeriodEnum: object = DatePeriodEnum;
  public isBooleanType: boolean;
  public isStringType: boolean;
  public isDateType: boolean;
  public isNumericType: boolean;
  public isDaysForward: boolean;
  public isDaysBack: boolean;
  public trueLabel: string = '';
  public falseLabel: string = '';
  public dropdownOptions: { label: string; value: string }[] = [];
  public numberOfDaysSince: number;
  fieldValueOperatorOptions = FieldValueOperatorEnum;
  binaryOperatorEnum = BinaryOperatorEnum;

  public selectedOption: ExpressionOptionComponent;

  public selectedDate: Date;
  public selectedSecondDate: Date;

  @ContentChildren(ExpressionOptionComponent) public childOptions: QueryList<ExpressionOptionComponent>;

  public constructor() {
    this.binarySelectorHidden = false;
    this.searchExpression = new SerialSearchExpression();
    this.selectedOption = null;
    this.isBooleanType = false;
    this.isStringType = true;
    this.isDateType = false;
    this.isNumericType = false;
    this.selectedDate = new Date();
    this.selectedSecondDate = new Date();
  }

  /**
   * afterinit
   **/
  public ngAfterContentInit(): void {
    // need to wait for custom fields
    setTimeout(() => {
      this.handleExpressionFieldChange(this.searchExpression.Field, true);
      if (this.isDateType && this.searchExpression.Value && Date.parse(this.searchExpression.Value)) {
        this.selectedDate = new Date(this.searchExpression.Value);
      }
      if (
        this.isDateType &&
        this.searchExpression.FieldValueOperator == FieldValueOperatorEnum.Between &&
        this.searchExpression.Value2 &&
        Date.parse(this.searchExpression.Value2)
      ) {
        this.selectedSecondDate = new Date(this.searchExpression.Value2);
      }
    }, 3000);
  }

  /**
   * handle field name change for contact info
   * @param searchExpression
   */
  public handleExpressionFieldChange(selectedField: any, initial?: boolean): void {
    this.selectedOption = this.childOptions.find((x) => {
      return x.value == selectedField;
    });
    if (this.selectedOption) {
      this.isBooleanType =
        this.selectedOption.fieldType == FieldTypeEnum.Bool || this.selectedOption.fieldType.toString().toLowerCase() == 'bool';
      this.isDateType =
        this.selectedOption.fieldType == FieldTypeEnum.Date || this.selectedOption.fieldType.toString().toLowerCase() == 'date';
      this.isDaysForward = this.isDateType && this.searchExpression.FieldValueOperator == FieldValueOperatorEnum.DaysForward;
      this.isDaysBack = this.isDateType && this.searchExpression.FieldValueOperator == FieldValueOperatorEnum.DaysForward;
      this.isNumericType =
        this.selectedOption.fieldType == FieldTypeEnum.Integer || this.selectedOption.fieldType.toString().toLowerCase() == 'integer';
      this.isNumericType =
        this.isNumericType ||
        this.selectedOption.fieldType == FieldTypeEnum.Decimal ||
        this.selectedOption.fieldType.toString().toLowerCase() == 'decimal';
      // enum is string type. fall back to string if previous options fall through
      this.isStringType =
        this.selectedOption.fieldType == FieldTypeEnum.String ||
        this.selectedOption.fieldType.toString().toLowerCase() == 'string' ||
        (!this.isBooleanType && !this.isDateType && !this.isNumericType);
      this.trueLabel = this.selectedOption.trueLabel;
      this.falseLabel = this.selectedOption.falseLabel;

      if (this.selectedOption.dropdownOptions) {
        this.dropdownOptions = this.selectedOption.dropdownOptions.map((x) => {
          return {
            label: x.label,
            value: x.value,
          };
        });
      } else {
        this.dropdownOptions = [];
      }
    } else {
      this.isStringType = true;
    }
    if (this.isDateType) {
      this.selectedDate = new Date();
      this.selectedDateChanged(this.selectedDate);
    } else if (!initial) {
      this.searchExpression.Value = '';
    }
  }

  public handleFieldValueOperatorChange() {
    if (this.searchExpression.FieldValueOperator == FieldValueOperatorEnum.Between) {
      this.selectedSecondDateChanged(new Date());
    }
  }

  public setSearchExpression(searchExpression: SerialSearchExpression, value: any) {
    searchExpression.Value = value;
  }

  public selectedDateChanged(value: Date) {
    this.searchExpression.Value = value.toISOString().slice(0, 10);
  }

  public selectedSecondDateChanged(value: Date) {
    this.searchExpression.Value2 = value.toISOString().slice(0, 10);
  }
}
